<div #panel class="vehicle-driver-panel-small__backdrop">
  <div class="vehicle-driver-panel-small__panel floating-panel">
    <div
      class="vehicle-driver-panel-small__heading"
      (click)="onClick()"
      (panstart)="onPanStart()"
      (pandown)="onPan($event)"
      (panup)="onPan($event)"
      (panend)="onPanEnd()"
    >
      <span class="vehicle-driver-panel-small__handle"></span>

      <ul class="vehicle-driver-panel-small__header tab-headers">
        <li
          class="tab-header"
          id="btn-vehicle-list"
          [class.tab-header--active]="activeTab === EVehicleDriverPanelTabs.VehicleList"
          (tap)="selectTab(EVehicleDriverPanelTabs.VehicleList)"
        >
          <mat-icon
            svgIcon="ic-tree"
            class="vehicle-driver-panel-small__header-image"
            i18n-fmTooltip="@@S_REPORT_SETTINGS_FLEET_SELECTION"
            fmTooltip="Fleet Selection"
          ></mat-icon>
          <span class="vehicle-driver-panel-small__header-text" i18n="@@S_GROUPS">Groups</span>
        </li>
        <li
          class="tab-header"
          id="btn-vehicle-status"
          [class.tab-header--active]="activeTab === EVehicleDriverPanelTabs.VehicleStatus"
          (tap)="selectTab(EVehicleDriverPanelTabs.VehicleStatus)"
        >
          <mat-icon
            svgIcon="ic-vehicle"
            class="vehicle-driver-panel-small__header-image"
            i18n-fmTooltip="@@S_RP_FLEETSTATUS"
            fmTooltip="Fleet Status"
          ></mat-icon>
          <span class="vehicle-driver-panel-small__header-text" i18n="@@S_FLEET">Fleet</span>
        </li>
        <li
          *ngIf="showTachoInformation"
          class="tab-header"
          id="btn-driver-status"
          [class.tab-header--active]="activeTab === EVehicleDriverPanelTabs.DriverStatus"
          (tap)="selectTab(EVehicleDriverPanelTabs.DriverStatus)"
        >
          <mat-icon
            svgIcon="ic-driver"
            class="vehicle-driver-panel-small__header-image"
            i18n-fmTooltip="@@S_DRIVERSTATUS"
            fmTooltip="Driver Status"
          ></mat-icon>
          <span class="vehicle-driver-panel-small__header-text" i18n="@@S_DRIVERS">Drivers</span>
        </li>
      </ul>
    </div>
    <ng-container #tabContent></ng-container>
    <ng-template #vehicleListTpl>
      <fm-vehicle-selection-panel
        [maxPlottableVehicles]="maxPlottableVehicles"
        [selectionMode]="vehicleSelectionMode"
        [vehicleListScopingTreeData]="vehicleListScopingTreeData"
        [vehicleListTreeData]="vehicleListTreeData"
        [isVehicleScopingEnabled]="isVehicleScopingEnabled"
        [isAssetsEnabled]="isAssetsEnabled"
        [anyPoweredAssets]="anyPoweredAssets"
        [anyNonPoweredAssets]="anyNonPoweredAssets"
        (editScopingClick)="onVehicleListEditScopingClick($event)"
        (selectionChange)="onVehicleListSelectionChange($event)"
        (selectionModeChange)="onVehicleListSelectionModeChange($event)"
        (vehicleClick)="onVehicleListSelectFocusVehicle($event)"
        (vehicleListScopingClose)="onVehicleListScopingClose()"
        (vehicleListScopingSave)="onVehicleListScopingSave($event)"
      ></fm-vehicle-selection-panel>
    </ng-template>
    <ng-template #vehicleStatusTpl>
      <div class="status-panel-content-container" [class.status-panel-ready]="isStatusPanelReady">
        <div
          class="vehicle-driver-panel-sort"
          *ngIf="hasFleetConnected && isStatusPlotsLoaded && (hasFleetSelected || selectedAttributes().length > 0)"
        >
          <div class="vehicle-driver-panel-sort__filters">
            <div class="vehicle-driver-panel-small__dropdown">
              <fm-status-sort-options
                [vehicleSortTypeSelected]="vehicleSortTypeSelected"
                (sortParamChanged)="onSortParamChange($event)"
              ></fm-status-sort-options>
              <fm-status-filter-options
                [showSkeleton]="attributeFiltering()"
                a7s-id="vehicle-driver-panel-status-filter"
                (statusFilterChanged)="onStatusFilterChange($event)"
                [statusFilterSelected]="statusFilterSelected"
                [statusCounts]="statusFilterCounts"
              ></fm-status-filter-options>
            </div>
            @if(isAttributeFilterEnabled()) {
            <fm-attribute-filter
              [showSkeleton]="attributeFiltering()"
              [containerRef]="elementRef"
              [attributeItems]="attributeItems()"
              [loading]="attributeLoading()"
              [error]="attributeError()"
              [selectedAttributes]="selectedAttributes()"
              (filterApplied)="filterApplied.emit($event)"
              (refreshClicked)="refreshClicked.emit()"
            ></fm-attribute-filter>
            }
            <div>
              @if(attributeFiltering()) {
              <div class="skeleton-circle"></div>
              } @else {

              <button class="vehicle-driver-panel-sort__button" mat-icon-button (click)="openVehicleDriverSortPanel()">
                <mat-icon
                  svgIcon="ic-sort"
                  class="mat-icon-size-xs line-height-xs"
                  i18n-fmTooltip="@@S_TRACKABLES_LIST_MOBILE_SORT_BY"
                  fmTooltip="Sort by"
                  a7s-id="live-map-selection-panel-sort-by"
                >
                </mat-icon>
              </button>
              }
            </div>
          </div>
          @if(isAttributeFilterEnabled()) {
          <fm-attribute-chips
            [selectedAttributes]="selectedAttributes()"
            [showSkeleton]="attributeFiltering()"
            (chipRemoved)="chipRemoved.emit($event)"
            (overflowClicked)="attributeFilterComponent()?.toggleFilter()"
          ></fm-attribute-chips>
          }
        </div>
        <fm-vehicle-status
          [ngClass]="{ 'vehicle-status__no-status-filter': !hasFleetConnected || !hasFleetSelected || !isStatusPlotsLoaded }"
          [hasFleetConnected]="hasFleetConnected"
          [hasFleetSelected]="hasFleetSelected"
          [isStatusPlotsLoaded]="isStatusPlotsLoaded"
          [showSkeleton]="attributeFiltering()"
          (clicked)="panDownPanel()"
        ></fm-vehicle-status>
      </div>
    </ng-template>
    <ng-template #driverStatusTpl>
      <fm-driver-status-panel
        [driverStatusData]="driverStatusData"
        [driverStatusFilter]="driverStatusFilter"
        [isDriverBreakDueFilterSelected]="isDriverBreakDueFilterSelected"
        [driverStatusSortType]="driverStatusSortType"
        [isDriverPlannerPageAllowed]="isDriverPlannerPageAllowed"
        (filterChange)="onFilterChange($event)"
        (driverBreakDueFilterChanged)="onDriverBreakDueFilterSelectedChange($event)"
        (driverStatusSortTypeChanged)="onStatusSortTypeChange($event)"
        (triggerZoomTo)="zoomToPosition($event)"
        (openDriverPlanner)="onOpenDriverPlanner()"
        (selectVehiclesClicked)="selectTab(EVehicleDriverPanelTabs.VehicleList)"
      >
      </fm-driver-status-panel>
    </ng-template>
  </div>
</div>
